import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-poll',
  template: `
    <p>
      edit-poll works!
    </p>
  `,
  styles: ``
})
export class EditPollComponent {

}
